const faqItems = [
  {
    id: 1,
    question: '51漫画免费版下载是否需要注册账号？',
    answer: '51漫画网大部分漫画资源无需注册即可免费下载。直接进入对应漫画页面，选择您需要的章节点击下载即可。注册账号后可享受书签同步、阅读历史、个性化推荐等增值服务，推荐使用免费账号解锁完整体验。',
  },
  {
    id: 2,
    question: '51漫画下载全集后如何离线阅读？',
    answer: '下载完成的漫画会自动保存在您设备的本地存储中。在51漫画APP中打开「我的下载」即可查看所有离线漫画，无需网络连接即可畅读。网页版下载的文件支持主流图片阅读器打开，方便您在电脑上离线翻阅。',
  },
  {
    id: 3,
    question: '51漫画下载资源更新频率是怎样的？',
    answer: '我们拥有专业的漫画更新团队，热门连载作品在官方发布后2-4小时内即可同步更新。每日凌晨和下午各进行一次集中更新，确保51漫画下载资源始终处于最新状态。完结作品一次性提供全集下载，新番持续追更不中断。',
  },
  {
    id: 4,
    question: '下载的漫画画质如何？支持哪些格式？',
    answer: '51漫画免费版下载提供高清原画画质，分辨率最高支持2560px宽度，完美适配手机、平板和电脑屏幕。下载格式统一为高清JPG/PNG，兼容所有主流设备和阅读器。部分热门作品还额外提供PDF打包下载，方便批量管理和打印。',
  },
  {
    id: 5,
    question: '51漫画下载是否安全？有病毒或广告吗？',
    answer: '5151漫画网高度重视用户安全，所有漫画下载文件均经过多重安全扫描，不含任何病毒或恶意程序。下载页面干净无弹窗广告，51漫画免费版下载过程不捆绑任何第三方软件。我们采用HTTPS加密传输，保障您的下载隐私与设备安全。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            关于51漫画下载的常见疑问，这里都有解答
          </p>
        </div>

        <div className="space-y-4">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/60"
            >
              <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-3 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center mt-0.5">
                  <i className="ri-question-answer-line text-primary-500 text-lg"></i>
                </span>
                {item.question}
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed pl-9">
                {item.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}